import { faFileAlt, faMicrophone, faTasks } from '@fortawesome/free-solid-svg-icons';
import { UserAction } from './userActionEnum.js';

export const ALL_INSIGHTS_TYPE_OPTIONS = [
  { value: 'documents', display: 'Documents', icon: faFileAlt },
  { value: 'consultations', display: 'Scribe', icon: faMicrophone },
  { value: 'tasks', display: 'Tasks', icon: faTasks },
];

export const defaultFiltersForInsightsType = (type) => {
  if (type === 'tasks') {
    return {
      selectedActions: [UserAction.COMPLETE, UserAction.DELETE],
      focusedAction: UserAction.COMPLETE
    };
  }
  if (type === 'consultations') {
    return {
      selectedActions: [UserAction.COMPLETE_RECORDING, UserAction.FILE_AWAY],
      focusedAction: UserAction.COMPLETE_RECORDING
    };
  }
  return {
    selectedActions: [UserAction.DELETE, UserAction.FILE_AWAY, UserAction.CREATE],
    focusedAction: UserAction.FILE_AWAY
  };
};
